import { useEffect } from 'react';

import { LoadError } from './errors';

export const getElementByIdInPopup = (elementId: string) => {
  let popup: Document | Element | null = document.querySelector('.popup-without-iframe');

  if (!popup) {
    const iframe = document.getElementById('TL_iframe') as HTMLIFrameElement;
    popup = iframe.contentWindow!.document;
  }

  return popup.querySelector(`#${elementId}`);
};

export const getElementByIdRegardlessOfContext = (elementId: string) => {
  try {
    const element = document.getElementById(elementId) || getElementByIdInPopup(elementId);
    return element;
  } catch {}
};

export const loadScript = (src: string, attributes: { qualifiedName: string; value: string }[] = []) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.addEventListener('load', resolve);
    script.addEventListener('error', () => reject(new LoadError(src)));

    for (const { qualifiedName, value } of attributes) {
      script.setAttribute(qualifiedName, value);
    }

    document.body.appendChild(script);
  });
};

export const loadStyle = (href: string) => {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = href;
    link.addEventListener('load', resolve);
    link.addEventListener('error', () => reject(new LoadError(href)));
    document.head.appendChild(link);
  });
};

export const useScrollToTopOnInit = () => {
  useEffect(() => {
    const root = document.getElementById('subsh')!;
    if (root) {
      root.scrollTo({ top: 0 });
    }
  }, []);
};
